import { EditScreenBskComponent } from './edit-screenbsk/edit-screenbsk.component';
import { AddScreenBskComponent } from './add-screenbsk/add-screenbsk.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListScreenBskComponent } from './list-screenbsk/list-screenbsk.component';

export const routesScreenBsk: Routes = [
    { path: 'page-screenbsk', component: ListScreenBskComponent},
    { path: 'page-screenbsk/add', component: AddScreenBskComponent},
    { path: 'page-screenbsk/:id/edit', component: EditScreenBskComponent}
];

export const ScreenBskRoutes: ModuleWithProviders = RouterModule.forChild(routesScreenBsk);
